function waitForJQuery(callback) {
    if (typeof jQuery !== 'undefined') {
        callback();
    } else {
        setTimeout(() => waitForJQuery(callback), 100);
    }
}

waitForJQuery(() => {
    console.log('jQuery Loaded.');

    document.dispatchEvent(new Event('jqueryLoaded'));

    (function ($) {
        const methods = {
            async addItem(data, discount = null) {
                try {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: data,
                    });
                    if (discount != null) {
                        await fetch('/cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                updates: {},
                                discount: discount,
                            }),
                        });
                    }
                    document.dispatchEvent(new Event("itemAddedToCart"));
                } catch (err) {
                    console.error('Erro ao adicionar item ao carrinho:', err);
                    throw err;
                }
            },

            async updateQuantityItem(lineKey, quantity) {
                try {
                    return await $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: {
                            updates: {
                                [lineKey]: quantity,
                            },
                        },
                        dataType: 'json',
                    });
                } catch (err) {
                    console.error('Erro ao atualizar a quantidade do item no carrinho:', err);
                    throw err;
                }
            },

            async clearCart() {
                return await $.ajax({
                    type: 'POST',
                    url: 'cart/clear.js',
                    data: {},
                    dataType: 'json',
                });
            },
        };

        window.FormEvents = methods;
    })(jQuery);

    (function ($) {
        const methods = {
            cartDrawer: $('#cart-drawer'),
            cartDrawerOverlay: $('.cart-drawer__overlay'),
            cartNeedsRefresh: true,

            _openDrawerVisual() {
                this.cartDrawer.removeClass('translate-x-full');
                this.cartDrawerOverlay.removeClass('opacity-0 pointer-events-none');
                document.documentElement.classList.add('overflow-hidden');
            },

            async openCartDrawer() {
                if (this.cartNeedsRefresh) {
                    await this.buildCart();
                } else {
                    this._openDrawerVisual();
                }
            },

            closeCartDrawer() {
                if (!this.cartDrawer.length || !this.cartDrawerOverlay.length) {
                    console.error('Cart drawer or overlay elements are missing.');
                    return;
                }

                this.cartDrawer.addClass('translate-x-full');
                this.cartDrawerOverlay.addClass('opacity-0 pointer-events-none');
                document.documentElement.classList.remove('overflow-hidden');
            },

            markCartForRefresh() {
                this.cartNeedsRefresh = true;
            },

            async buildCart() {
                try {
                    const cartItemsSection = await $.ajax({
                        url: `${routes.cart_url}?section_id=cart-items-drawer`,
                    });
                    const parser = new DOMParser();
                    const cartItemsContent = parser.parseFromString(cartItemsSection, 'text/html');
                    const $listItems = $(cartItemsContent).find('#cart-items-drawer');
                    const $quantityItems = Number($listItems.data('quantity-items')) || 0;
                    const $footerCheckout = $(cartItemsContent).find('#footer-checkout');
                    const $subTotalCart = $(cartItemsContent).find('#cart-subtotal');
                    const $totalCart = $(cartItemsContent).find('#cart-total');

                    if (!$listItems) {
                        console.warn('No cart items found in the response.');
                        $('.cart-drawer__footer').css('display', 'none');
                        this.cartNeedsRefresh = false;
                        return;
                    }

                    $('#cart-items-drawer').replaceWith($listItems);
                    $('#footer-checkout').replaceWith($footerCheckout);
                    $('.checkout-button').html(`${window.cartStrings.checkout}・${$totalCart.text()} <s class="opacity-50">${$subTotalCart.text()}</s>`);
                    $('#cart-drawer-count').html($quantityItems);

                    $quantityItems <= 0 ? $('.cart-drawer__footer').css('display', 'none') : $('.cart-drawer__footer').css('display', 'flex');

                    console.log('listItems', $listItems);

                    const itemCount = $listItems.find('.cart-drawer__items').data('quantity') || 0;
                    updateCartCountBadge(Number(itemCount));

                    const influencer = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);
                    if (influencer) {
                        StoreUtils.applyDiscountToProducts('influencer', '.card-product', true);
                    } else {
                        StoreUtils.applyDiscountToProducts('normal', '.card-product', true);
                    }

                    document.dispatchEvent(new CustomEvent("buildCart", {
                        detail: { listItems: $listItems[0] }
                    }));

                    const $cart_drawer_items = $('#cart-drawer__items');
                    const currentHeight = $cart_drawer_items.outerHeight();
                    $cart_drawer_items.css('height', currentHeight + 300 + 'px');

                    await this.upsell();
                    this._openDrawerVisual();
                    this.cartNeedsRefresh = false;
                } catch (err) {
                    console.error('Erro ao construir o carrinho:', err);
                }
            },
            async upsell() {
                try {
                    const cartUpsellSection = await $.ajax({
                        url: `${routes.cart_url}?section_id=cart-drawer-upsell`,
                        dataType: 'html'
                    });
                    const parser = new DOMParser();
                    const cartItemsUpsell = parser.parseFromString(cartUpsellSection, 'text/html');
                    const $listItems = $(cartItemsUpsell).find('#cart-drawer__upsell');

                    if (!$listItems.length) {
                        console.warn('No cart items found in the response.');
                        return;
                    }

                    $('#cart-drawer__upsell').replaceWith($listItems);
                    const influencer = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);
                    if (influencer) {
                        StoreUtils.applyDiscountToProducts('influencer', '.card-product', true);
                    } else {
                        StoreUtils.applyDiscountToProducts('normal', '.card-product', true);
                    }

                    const splide = new Splide('.cart-drawer-upsell', {
                        type: 'slide',
                        perPage: 2,
                        arrows: false,
                        padding: { right: '30px' },
                        pagination: false,
                        gap: '8px',
                    });

                    splide.mount();
                } catch (err) {
                    console.error('Erro ao construir o carrinho:', err);
                }
            },
        };

        window.CartDrawerAPI = methods;

        document.addEventListener('itemAddedToCart', function () {
            CartDrawerAPI.markCartForRefresh();
        });
    })(jQuery);

    (function ($) {
        const methods = {
            showPrices(card, userIdentifier, containsATC = false) {
                const priceElement = card.querySelector('.card-product__price');
                const comparePriceElement = card.querySelector('.card-product__compare_price');
                const priceInput = card.querySelector('.product_price');
                const discountInput = card.querySelector('.influencer_discount');
                let influencerCodeInput = card.querySelector('.product-influencer-input-code');
                let attributePartnerCode = card.querySelector('input[name="attributes[partnerCode]"]');
                const containerPorcentageDiscountInCard = card.querySelector('.container-porcentage-discount');
                const valuePorcentageDiscountInCard = containerPorcentageDiscountInCard ? containerPorcentageDiscountInCard.querySelector('.porcentage-discount') : null;
                const partnerCodeFromLocalStorage = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);

                if (!influencerCodeInput && !attributePartnerCode) {
                    const buyTogetherElement = card.closest(".buy-together");
                    influencerCodeInput = buyTogetherElement ? buyTogetherElement.querySelectorAll('.product-influencer-input-code') : null;
                    attributePartnerCode = buyTogetherElement ? buyTogetherElement.querySelector('input[name="attributes[partnerCode]"]') : null;
                };

                if (!priceElement || !priceInput || !discountInput) {
                    console.warn('Missing elements in card:');
                    return;
                }

                if (containsATC && !influencerCodeInput) {
                    console.log("Missing Influencer Input in Card");
                }
                else if (containsATC && influencerCodeInput) {
                    // Apply attributes cart/product
                    if (influencerCodeInput.length > 1) {
                        influencerCodeInput.forEach((element, index) => {
                            if (index == discountInput.dataset.index) {
                                if (!element.value) {
                                    element.value = userIdentifier === 'influencer' ? partnerCodeFromLocalStorage : '';
                                }
                            }
                        });
                        attributePartnerCode.value = userIdentifier === 'influencer' ? `${partnerCodeFromLocalStorage}` : '';
                    }
                    else {
                        influencerCodeInput.value = userIdentifier === 'influencer' ? partnerCodeFromLocalStorage : '';
                        attributePartnerCode.value = userIdentifier === 'influencer' ? `${partnerCodeFromLocalStorage}` : '';
                    };
                };

                const originalPrice = parseFloat(priceInput.value) / 100 || 0;
                const discountValue = parseFloat(discountInput.value);


                if (userIdentifier === 'influencer' && discountValue > 0) {
                    const discountedPrice = StoreUtils.calculateDiscountedPrice(originalPrice, discountValue);
                    const discountPercentage = StoreUtils.calculateDiscountedPriceInPercentage(discountValue, originalPrice);

                    if (discountedPrice) {
                        priceElement.textContent = StoreUtils.formatCurrency(discountedPrice);

                        if (valuePorcentageDiscountInCard) {
                            if (discountPercentage < 4) {
                                valuePorcentageDiscountInCard.textContent = `${StoreUtils.formatCurrency(discountValue)}`;
                            } else {
                                valuePorcentageDiscountInCard.textContent = discountPercentage > 100 ? '100%' : `${discountPercentage}%`;
                            }
                        }

                        priceElement.style.opacity = 1;
                        if (containerPorcentageDiscountInCard) {
                            containerPorcentageDiscountInCard.style.opacity = 1;
                        }
                        if (comparePriceElement) {
                            comparePriceElement.style.opacity = 1;
                        }
                        if (comparePriceElement) {
                            comparePriceElement.style.opacity = 1;
                        }
                    }
                } else {
                    priceElement.textContent = StoreUtils.formatCurrency(originalPrice);
                    priceElement.style.opacity = 1;
                    if (comparePriceElement) {
                        comparePriceElement.remove();
                    }
                }
            },
        };

        window.CardProducts = methods;
    })(jQuery);

    function triggerEventQuantityProductForm() {
        const quantityInput = document.querySelector('#product-form #product-form-quantity');

        if (quantityInput) {
            quantityInput.value = 1;
            const event = new Event('input', {
                bubbles: true,
                cancelable: true,
            });
            quantityInput.dispatchEvent(event);
        }
    }

    function removeClosestQuantityButtons() {
        const cartItems = document.querySelectorAll('.upez--cart-item');

        cartItems.forEach((cartItemContainer) => {
            const hasHiddenQuantityInput = !!cartItemContainer.querySelector(
                'input[type="hidden"][id^="hidden_quan"], input[type="hidden"][value="hidden_quantity"]'
            );
            const quantityWrappers = cartItemContainer.querySelectorAll('.upez-action');
            const quantityButtons = cartItemContainer.querySelectorAll('.upez-quantity-selector');

            if (!quantityWrappers.length && !quantityButtons.length) {
                return;
            }

            if (hasHiddenQuantityInput) {
                quantityWrappers.forEach((wrapper) => {
                    const hasDeleteAction = !!wrapper.querySelector('[upnova-action="delete"]');

                    if (hasDeleteAction) {
                        if (wrapper.style.display === 'none') {
                            wrapper.style.display = '';
                        }
                        return;
                    }

                    if (!hasDeleteAction) {
                        wrapper.style.display = 'none';
                    }
                });

                quantityButtons.forEach((button) => {
                    if (button instanceof HTMLElement) {
                        button.style.display = 'none';
                    }
                });
                return;
            }

            quantityWrappers.forEach((wrapper) => {
                if (wrapper.style.display === 'none') {
                    wrapper.style.display = '';
                }
            });

            quantityButtons.forEach((button) => {
                if (button instanceof HTMLElement && button.style.display === 'none') {
                    button.style.display = '';
                }
            });
        });
    }

    function monitorBuilderStateForQuantityRemoval() {
        const builderSelector = '[builder-id="builder-cf0b234beb2f43b2ac3f096fc19e469d"]';
        let builderStyleObserver = null;
        let scheduledValidation = null;

        function hasExpectedBuilderStyles(element) {
            if (!element) {
                return false;
            }

            const computedStyle = window.getComputedStyle(element);
            const normalizedTransition = computedStyle.transition.replace(/\s+/g, ' ').trim();

            return (
                computedStyle.pointerEvents === 'none' &&
                computedStyle.opacity === '1' &&
                normalizedTransition.includes('0.5s') &&
                normalizedTransition.includes('cubic-bezier(0.37, 0.01, 0, 0.98)')
            );
        }

        function hasVisibleQuantityButtons() {
            return Array.from(document.querySelectorAll('.upez-button.upez-quantity-selector')).some((element) => {
                if (!(element instanceof HTMLElement)) {
                    return false;
                }

                const computedStyle = window.getComputedStyle(element);
                return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && computedStyle.opacity !== '0';
            });
        }

        function shouldRemoveQuantity() {
            const builderElements = document.querySelectorAll(builderSelector);

            if (!builderElements.length) {
                return false;
            }

            return Array.from(builderElements).some((builderElement) => hasExpectedBuilderStyles(builderElement));
        }

        function scheduleValidation() {
            if (scheduledValidation) {
                return;
            }

            scheduledValidation = requestAnimationFrame(() => {
                scheduledValidation = null;
                validateAndRemoveQuantity();
            });
        }

        function validateAndRemoveQuantity() {
            if (shouldRemoveQuantity() && hasVisibleQuantityButtons()) {
                removeClosestQuantityButtons();
            }
        }

        function watchBuilderElement() {
            const builderElement = document.querySelector(builderSelector);

            if (!builderElement) {
                return;
            }

            if (builderStyleObserver) {
                builderStyleObserver.disconnect();
            }

            builderStyleObserver = new MutationObserver(scheduleValidation);
            builderStyleObserver.observe(builderElement, {
                attributes: true,
                attributeFilter: ['style', 'class'],
            });

            scheduleValidation();
        }

        const domObserver = new MutationObserver(() => {
            watchBuilderElement();
            scheduleValidation();
            removeClosestQuantityButtons();
        });

        domObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class'],
        });

        setInterval(() => {
            scheduleValidation();
            removeClosestQuantityButtons();
        }, 300);

        watchBuilderElement();
        scheduleValidation();
        removeClosestQuantityButtons();
    }

    monitorBuilderStateForQuantityRemoval();

    $(document).on('submit', 'form[action*="/cart/add"]', async function (e) {
        e.preventDefault();
        const $form = $(this);
        const add_to_cart = $form.find('button[type="submit"] #add-to-cart');
        const add_to_cart_loading = $form.find('button[type="submit"] #loading-add-to-cart');
        const floating_content = $form.find('#floating-buy-bar-content');
        const floating_loading = $form.find('#floating-buy-bar-loading');

        if (add_to_cart && add_to_cart_loading) {
            add_to_cart.addClass('hidden');
            add_to_cart.removeClass('flex');
            add_to_cart_loading.addClass('flex');
            add_to_cart_loading.removeClass('hidden');
        }
        if (floating_content.length && floating_loading.length) {
            floating_content.addClass('hidden');
            floating_loading.addClass('inline-flex').removeClass('hidden');
        }

        try {
            if ($form.serialize().includes('bogo')) {
                await FormEvents.addItem($form.serialize(), 'getafree');
            } else {
                await FormEvents.addItem($form.serialize());
                const $swatchLabels = jQuery('.variant-swatch');

                if ($swatchLabels.length) {
                    const $input = $swatchLabels.find('input[name="variant"]').first();
                    if ($input.length) {
                        $input.trigger('click');
                    }
                }
            }

            if (add_to_cart && add_to_cart_loading) {
                add_to_cart.removeClass('hidden');
                add_to_cart.addClass('flex');
                add_to_cart_loading.addClass('hidden');
                add_to_cart_loading.removeClass('flex');
            }
            if (floating_content.length && floating_loading.length) {
                floating_content.removeClass('hidden');
                floating_loading.addClass('hidden').removeClass('inline-flex');
            }

            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.upsell();

            if (window.location.pathname.includes('/products/')) {
                $form.find('#product-form-quantity').val(1);
                triggerEventQuantityProductForm();
            };
        } catch (err) {
            console.error('Erro ao adicionar item ao carrinho:', err);
            if (add_to_cart && add_to_cart_loading) {
                add_to_cart.removeClass('hidden');
                add_to_cart.addClass('flex');
                add_to_cart_loading.addClass('hidden');
                add_to_cart_loading.removeClass('flex');
            }
            if (floating_content.length && floating_loading.length) {
                floating_content.removeClass('hidden');
                floating_loading.addClass('hidden').removeClass('inline-flex');
            }
        }
    });

    $(document).on('click', '#header-cart-icon', async function () {
        await CartDrawerAPI.openCartDrawer();
    });
    $(document).on('click', '.cart-drawer__close, .cart-drawer__overlay', async function () {
        await CartDrawerAPI.closeCartDrawer();
    });

    function updateCartCountBadge(quantity) {
        const itemCount = quantity ?? 0;

        const badge = document.getElementById('cart-count-badge');
        if (badge) {
            badge.textContent = itemCount;
            if (itemCount > 0) {
                badge.classList.remove('hidden');
            } else {
                badge.classList.add('hidden');
            }
        }
    }

    if (window.location.href.includes('openCart') && !window.__newCartDrawer) {
        CartDrawerAPI.openCartDrawer();
    };
});